import type { CheckoutCustomPayload } from "@product/rosetta-sdk";
import { useCallback } from "react";

import { useLoginDialogStateHelper } from "~/components/login-dialog/hooks";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGTMSubscribeVariables } from "~/components/tracking/google-tag-manager/apis";
import { getGoogleLoginUrl } from "~/lib/account";

import { RegiWallLoginMethodLocalstorageKey } from "./consts";

export const useRosettaCheckoutCustomEventHandler = () => {
  const { openLoginDialog } = useLoginDialogStateHelper();

  const handleCustomEvent = useCallback(
    (payload: CheckoutCustomPayload) => {
      // TODO: add tracking event here
      switch (payload.eventName) {
        case "regiwall-google-signin":
          localStorage.setItem(RegiWallLoginMethodLocalstorageKey, "Google");
          location.href = getGoogleLoginUrl({
            registerSource: "loginwall",
          });
        case "loginwall-meter-signin":
        case "loginwall-meter-signup":
        case "regiwall-signin":
          openLoginDialog({
            description: "To continue reading, create your free account or log in now",
            destination: window.location.origin + window.location.pathname,
            wallType: "regi",
          });
          break;
        case "regiwall-elections-meter-signup":
          openLoginDialog({
            description: "To continue reading, create your free account or log in now",
            destination: window.location.origin + window.location.pathname,
            registrationTerm: "hkelections",
            wallType: "regi",
          });
          break;
        case "regiwall-elections-meter-redeem":
          const updatedUrl = new URL(window.location.href);
          // cspell: ignore hkelections
          updatedUrl.searchParams.set("hkelections", "true");
          window.location.href = updatedUrl.href;
          break;
        case "onboarding-direct-checkout":
          if (!payload?.params) return;
          const { params } = payload;
          if (params.plan) {
            sendGTMSubscribeVariables({
              meter: params.meter,
              period: params.plan,
              plan: `${params.plan === "year" ? "Annual" : "Monthly"}: Digital | ${
                params.currency
              }`,
              price: params.price,
            });
          }
          sendGATracking({
            action: params.action,
            category: "Onboarding/Pop-up",
            label: window.location.href,
          });
          break;
      }
    },
    [openLoginDialog],
  );

  return {
    handleCustomEvent,
  };
};
